/**
 * Created by valerasiestov on 10.12.15.
 */


if (!window.module) {
    window.module = {};
}

module.sidebar = (function () {
    "use strict";

    var controls = {},
        handlers = {
            scroll: function (event) {
                var doc = document,
                    top = event.target.scrollTop || doc.documentElement.scrollTop || doc.body.scrollTop,
                    info = controls.info,
                    infoStyle = info.style,
                    offsetBottom,
                    setFixed = function () {
                        infoStyle.left = '';
                        info.classList.remove('fixed');
                        infoStyle.top = 'auto';
                        infoStyle.bottom = controls.bottomOffset + 'px';
                    };

                if (top >= controls.topPosition) {

                    if (!info.classList.contains('fixed')) {
                        infoStyle.left = '';
                        infoStyle.top = '';
                        infoStyle.bottom = '';
                        infoStyle.left = info.getBoundingClientRect().left + 'px';
                        info.classList.add('fixed');
                    }

                    offsetBottom =
                        controls.windowHeight > controls.infoHeight ? controls.windowHeight : controls.infoHeight;

                    if (controls.pageList && controls.pageList.length) {
                        if (!controls.pageList[1].classList.contains('active')) {
                            if (top >= controls.offerBlockPosition - offsetBottom) {
                                setFixed();
                            }
                        } else {
                            if (top >= controls.industryBottomPosition - offsetBottom) {
                                infoStyle.left = '';
                                info.classList.remove('fixed');
                                infoStyle.top = 'auto';
                                infoStyle.bottom = 0 + 'px';
                            }
                        }
                    } else {

                        if (top >= controls.offerBlockPosition - offsetBottom) {
                            setFixed();
                        }

                    }



                } else {
                    infoStyle.left = '';
                    infoStyle.top = '';
                    infoStyle.bottom = '';
                    info.classList.remove('fixed');
                }

            },

            resize: function (event) {
                var windowHeight,
                    size;

                controls.windowHeight = windowHeight = window.innerHeight;

                if (!controls.pageList[1].classList.contains('active')) {
                    size = controls.fullSize;
                } else {
                    size = controls.industryHeight;
                }

                if (size > windowHeight) {

                    if (controls.infoHeight > windowHeight) {
                        controls.info.style.height = controls.infoHeight + 'px';
                    } else {
                        controls.info.style.height = windowHeight + 'px';
                    }

                } else {
                    controls.info.style.height = size + 'px';
                }
            }
        };

    function changeContent() {
        if (controls.pageList[1].classList.contains('active')) {
            controls.industryHeight = controls.industry.clientHeight;
            controls.industryBottomPosition = $(controls.industry).offset().top + controls.industryHeight;
            controls.style.textContent = controls.style.innerText = '';
            handlers.resize();
        } else {
            controls.style.textContent = controls.style.innerText =
                '.floating-container:before {content: ""; display: block; height: ' + controls.fullSize + 'px;}'
        }
    }

    function setBlockSize() {
        var items = controls.listItems,
            count = items.length,
            consultationHeight = 0,
            margin = parseFloat(getComputedStyle(items[0]).marginBottom),
            offsetHeight = 0,
            fullSize = 0,
            i,
            style,
            windowHeight = window.innerHeight;

        controls.windowHeight = windowHeight;
        controls.topPosition = $(controls.list).offset().top;

        consultationHeight += items[count - 1].clientHeight + items[count - 2].clientHeight + margin;
        offsetHeight += items[count - 3].clientHeight;

        for (i = 0; i < count - 3; i++) {
            fullSize += items[i].clientHeight + margin;
        }

        fullSize -= margin;
        controls.fullSize = fullSize;

        style = document.createElement('style');
        controls.style = style;

        style.setAttribute('rel', "stylesheet");
        style.textContent = style.innerText = '.floating-container:before {content: ""; display: block; height: ' + fullSize + 'px;}';
        document.head.appendChild(style);

        controls.container.classList.add('floating-container');
        controls.info.style.width = getComputedStyle(controls.info).width;

        controls.info.classList.add('floating');
        controls.infoHeight = controls.info.clientHeight;

        if (!controls.offerBlock) {
            fullSize += items[count - 3].clientHeight + margin;
            fullSize += items[count - 2].clientHeight + margin;
            fullSize += items[count - 1].clientHeight;

            controls.fullSize = fullSize;
        }

        if (fullSize > windowHeight) {
            if (controls.infoHeight > windowHeight) {
                controls.info.style.height = controls.infoHeight + 'px';
            } else {
                controls.info.style.height = windowHeight + 'px';
            }
        } else {
            controls.info.style.height = fullSize + 'px';
        }

        if (controls.offerBlock) {
            controls.offerBlock.style.cssText = 'height: ' + offsetHeight + 'px; max-height: ' + offsetHeight + 'px;';
            controls.offerBlockPosition = $(controls.offerBlock).offset().top - margin;
            controls.bottomOffset = offsetHeight + consultationHeight + margin * 2;
        } else {
            controls.offerBlockPosition = controls.topPosition + controls.list.clientHeight;
            controls.bottomOffset = 0;
        }

        if (controls.consultation) {
            controls.consultation.style.cssText = 'height: ' + consultationHeight + 'px; max-height: ' + consultationHeight + 'px;';
        }


        handlers.scroll.call(window, {target: window});
    }

    function setEventList() {
        window.addEventListener('scroll', handlers.scroll, false);
        window.addEventListener('resize', handlers.resize, false);
    }

    function getControls(params) {
        controls.container = document.querySelector(params.sidebar);
        controls.list = document.querySelector(params.list);

        if (!controls.container || !controls.list) {
            return false;
        }

        controls.info = controls.container.querySelector('.offers__info');
        controls.consultation = controls.container.querySelector('.offers__info-red');
        controls.offerBlock = controls.container.querySelector('.offers__info-triangle');
        controls.listItems = controls.list.querySelectorAll('.offers__item');
        controls.pageList = document.querySelectorAll('.page__offers li a');
        controls.industry = document.querySelector('.industry__list');
        controls.params = params;

        return true;
    }

    function init(params) {
        if (getControls(params)) {
            setBlockSize();
            setEventList();
        }
    }

    return {
        init: init,
        changeContent: changeContent
    };

}());

window.addEventListener('load', function () {

    if (document.querySelector('.compressors_page')) {
        module.sidebar.init({
            sidebar: '.sidebar',
            list: '.offers__list'
        });
    }


}, false);
 